import React, {useEffect, useRef} from 'react';
import {FiX} from "react-icons/fi";
import {closeDrawer} from "@/components/dispatch_functions.ts";
import {createPortal} from "react-dom";


function Drawer({children, position, id, title}:{
    children: React.ReactNode,
    id?: string;
    position:'start' | 'end',
    title?: string,
}) {
    const ref = useRef(null);
    useEffect(() => {
        const handler = (e) => {
            if(e.detail.id === id){
                ref.current.checked = true;
            }
        }
        const closeDrawer = (e) => {
            if(e.detail.id === id){
                ref.current.checked = false;
            }
        }
        window.addEventListener('close_drawer', closeDrawer)
        window.addEventListener('show_drawer', handler)
        return ()=>{
            window.removeEventListener('close_drawer', closeDrawer)
            window.removeEventListener('show_drawer', handler)
        }
    }, [id]);
    const positionToCls = {
        start: 'drawer-start',
        end: 'drawer-end'
    }
    return createPortal(<div className={`drawer ${positionToCls[position]}`}>
            <input id={id || "my-drawer"} ref={ref} type="checkbox" onChange={(e)=>{
                window.dispatchEvent(new CustomEvent('drawer_closed', {
                    detail: {
                        id
                    }
                }))
            }} className="drawer-toggle"/>
            <div className="drawer-side">
                <label htmlFor={id || "my-drawer"} aria-label="close sidebar" className="drawer-overlay"></label>
                <div className="menu bg-base-100 text-base-content min-h-full sm:w-96 w-full">
                    <div className={"flex mt-1 justify-between items-center ps-4 pe-1"}>
                        <h3 className={"text-2xl"}>{title}</h3>
                        <button onClick={()=>closeDrawer(id)} className="btn btn-ghost">
                            <FiX size={24}/>
                        </button>
                    </div>
                    <div className="flex-1 flex flex-col ">
                        {children}
                    </div>
                </div>
            </div>
        </div>,document.body)

}

export default Drawer;
